import { Component, OnInit } from '@angular/core';
import { SupervisionService } from 'src/app/services/supervision.service';

@Component({
  selector: 'app-volumetrie-traitees',
  templateUrl: './volumetrie-traitees.component.html',
  styleUrls: ['./volumetrie-traitees.component.css']
})
export class VolumetrieTraiteesComponent implements OnInit {

  volumetrieTraitees : any; //=> Données à afficher sur la barChart

  volumetrieTraiteesOptions : any = {
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true
          },
          stacked: true
        }
      ],
      xAxes: [
        {
          ticks: {
            beginAtZero: true
          },
          stacked: true
        }
      ]
    },
    plugins : {
      datalabels: {
        color : '#000000',
        font: {
          weight:'bold',
          size: 16
        }
      }
    }
  }

  constructor(private supervisionService : SupervisionService) { }

  ngOnInit(): void {
    this.getVolumetrieTraitees();
  }


  getVolumetrieTraitees() {
    this.supervisionService.getVolumetrie().subscribe(value => {
      if(value["status"] !== "success"){
        console.log("Une erreur dans la requête:" + value["cause"]);
      }else {
        let data = value['data'];
        this.volumetrieTraitees = {
          labels: data.map(current => current.mois_action),
          datasets : [
            {
              label: 'OK',
              backgroundColor: '#6495ED',
              borderColor: '#1E88E5',
              data: data.map(current => current.ok)
            },
            {
              label: 'KO',
              backgroundColor: '#FFA07A',
              borderColor: '#1E88E5',
              data: data.map(current => current.ko)
            },
          ]
        };




      }
    });
  }

}
